/* Adventure Parked colour-in touring map. Used by sections/touring-map.liquid; county shapes come from touring-map-1.js to touring-map-4.js. */
(function () {
function initTouringMap(root) {
  if (!root || root.__aptm) return; root.__aptm = true;
  var $ = function (sel) { return root.querySelector('[data-aptm-' + sel + ']'); };
  var seen = {}; // the theme editor can load the county files twice; keep one of each
  var COUNTIES = (window.APTM || []).filter(function (c) { if (seen[c.id]) return false; seen[c.id] = 1; return true; });
  var MAP = { x: -281, w: 1481, h: 2014, inset: [766.2, 6.2, 145.8, 237.2] };
  var NAMES = { 'durham': 'County Durham', 'edinburgh': 'City of Edinburgh', 'glasgow': 'City of Glasgow', 'dundee': 'City of Dundee' };
  var NATION = {};
  ['antrim','armagh','down','fermanagh','londonderry','tyrone'].forEach(function (k) { NATION[k] = 'Northern Ireland'; });
  ['aberdeen-city','aberdeenshire','angus','argyll-and-bute','ayrshire-and-arran','banffshire','berwickshire','caithness','clackmannanshire','dumfries','dunbartonshire','dundee','east-lothian','edinburgh','fife','glasgow','inverness','kincardineshire','lanarkshire','midlothian','moray','nairn','orkney','perth-and-kinross','renfrewshire','ross-and-cromarty','roxburgh--ettrick-and-lauderdale','shetland','stirling-and-falkirk','sutherland','tweeddale','west-lothian','western-isles','wigtown'].forEach(function (k) { NATION[k] = 'Scotland'; });
  ['clwyd','dyfed','gwent','gwynedd','mid-glamorgan','powys','south-glamorgan','west-glamorgan'].forEach(function (k) { NATION[k] = 'Wales'; });
  ['carlow','cavan','clare','cork','donegal','dublin','galway','kerry','kildare','kilkenny','laois','leitrim','limerick','longford','louth','mayo','meath','monaghan','offaly','roscommon','sligo','tipperary','waterford','westmeath','wexford','wicklow'].forEach(function (k) { NATION[k] = 'Republic of Ireland'; });
  // Deeper versions of the 2027 wall planner colours. Order matters: map links store the position.
  var COLOURS = [
    { id: 'sunshine', name: 'Sunshine', hex: '#F5C542' },
    { id: 'peach', name: 'Peach', hex: '#F48F78' },
    { id: 'meadow', name: 'Meadow', hex: '#7CCB6E' },
    { id: 'mint', name: 'Mint', hex: '#4FD1A9' },
    { id: 'aqua', name: 'Aqua', hex: '#5CC6E6' },
    { id: 'sky', name: 'Sky', hex: '#7FB2F0' },
    { id: 'lavender', name: 'Lavender', hex: '#9C93EE' }
  ];
  var KEY = 'ap-touring-map-v1', MKEY = 'ap-club-member';
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var firstVisit = store.get(KEY) === null;
  var state = { title: '', sub: '', colour: 'sunshine', visited: {} };
  try { var saved = JSON.parse(store.get(KEY) || '{}'); for (var k in saved) state[k] = saved[k]; } catch (e) {}
  var hexOf = function (id) { for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i].id === id) return COLOURS[i].hex; return COLOURS[0].hex; };
  if (!COLOURS.some(function (c) { return c.id === state.colour; })) state.colour = COLOURS[0].id;
  var save = function () { store.set(KEY, JSON.stringify(state)); };
  var nameOf = function (c) { return NAMES[c.id] || c.name; };
  var byId = {}; COUNTIES.forEach(function (c) { byId[c.id] = c; });
  var ORDER = COUNTIES.map(function (c) { return c.id; }).sort();

  // Membership
  var params = new URLSearchParams(location.search);
  var member = root.dataset.member === 'true' || store.get(MKEY) === '1';
  var justJoined = params.get('customer_posted') === 'true' || params.get('member') === '1';
  // An email that's already in the club shows "already signed up" in the gate form: treat that as a member coming back.
  var gateErr = root.querySelector('[data-aptm-gate] .apc__err');
  var alreadyMember = !!(gateErr && /already/i.test(gateErr.textContent));
  if (justJoined || alreadyMember) { member = true; store.set(MKEY, '1'); }

  // Map link: #m=<one character per county, 0 = not coloured, 1-7 = colour>
  function encode() {
    var s = ''; ORDER.forEach(function (id) { var v = state.visited[id]; var i = -1; COLOURS.forEach(function (c, j) { if (c.id === v) i = j; }); s += String(i + 1); });
    return s.replace(/0+$/, '');
  }
  var linkLoaded = false;
  var hm = location.hash.match(/(?:^#|&)m=([0-7]+)/);
  if (hm) {
    var code = hm[1], v = {};
    ORDER.forEach(function (id, i) { var n = +(code[i] || 0); if (n > 0 && COLOURS[n - 1]) v[id] = COLOURS[n - 1].id; });
    state.visited = v; linkLoaded = true; save();
    var tm = location.hash.match(/(?:^#|&)t=([^&]*)/); if (tm) { try { state.title = decodeURIComponent(tm[1]).slice(0, 40); } catch (e) {} }
    var sm = location.hash.match(/(?:^#|&)s=([^&]*)/); if (sm) { try { state.sub = decodeURIComponent(sm[1]).slice(0, 40); } catch (e) {} }
    save();
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
  }

  // Draw the map
  var svg = $('map'), NS = 'http://www.w3.org/2000/svg';
  var full = { x: MAP.x, y: 0, w: MAP.w, h: MAP.h }, vb = { x: MAP.x, y: 0, w: MAP.w, h: MAP.h };
  var setVB = function () { svg.setAttribute('viewBox', vb.x + ' ' + vb.y + ' ' + vb.w + ' ' + vb.h); };
  setVB();
  var ins = document.createElementNS(NS, 'rect');
  ins.setAttribute('x', MAP.inset[0]); ins.setAttribute('y', MAP.inset[1]); ins.setAttribute('width', MAP.inset[2]); ins.setAttribute('height', MAP.inset[3]);
  ins.setAttribute('rx', 8); ins.setAttribute('class', 'aptm__inset'); svg.appendChild(ins);
  var paths = {};
  COUNTIES.forEach(function (c) {
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', c.d); p.setAttribute('fill-rule', 'evenodd'); p.setAttribute('tabindex', '0'); p.setAttribute('role', 'button');
    p.setAttribute('data-id', c.id);
    var t = document.createElementNS(NS, 'title'); t.textContent = nameOf(c); p.appendChild(t);
    svg.appendChild(p); paths[c.id] = p;
  });

  // County list
  var list = $('list'), boxes = {};
  ['England', 'Scotland', 'Wales', 'Northern Ireland', 'Republic of Ireland'].forEach(function (nation) {
    var g = document.createElement('div'); g.setAttribute('data-group', nation);
    var h = document.createElement('h3'); h.textContent = nation; g.appendChild(h);
    COUNTIES.filter(function (c) { return (NATION[c.id] || 'England') === nation; })
      .sort(function (a, b) { return nameOf(a).localeCompare(nameOf(b)); })
      .forEach(function (c) {
        var l = document.createElement('label');
        var cb = document.createElement('input'); cb.type = 'checkbox';
        cb.addEventListener('change', function () { toggle(c.id, cb.checked); });
        var sp = document.createElement('span'); sp.textContent = nameOf(c);
        var d = document.createElement('i'); d.className = 'aptm__dot';
        l.appendChild(cb); l.appendChild(sp); l.appendChild(d); l.setAttribute('data-name', nameOf(c).toLowerCase());
        g.appendChild(l); boxes[c.id] = { cb: cb, dot: d };
      });
    list.appendChild(g);
  });
  $('q').addEventListener('input', function (e) {
    var q = e.target.value.trim().toLowerCase();
    list.querySelectorAll('[data-group]').forEach(function (g) {
      var any = false;
      g.querySelectorAll('label').forEach(function (l) { var ok = !q || l.getAttribute('data-name').indexOf(q) > -1; l.hidden = !ok; any = any || ok; });
      g.hidden = !any;
    });
  });

  // Swatches
  var sw = $('swatches');
  COLOURS.forEach(function (c) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'aptm__swatch';
    b.setAttribute('aria-pressed', String(state.colour === c.id));
    var dot = document.createElement('span'); dot.style.background = c.hex; b.appendChild(dot); b.appendChild(document.createTextNode(c.name));
    b.addEventListener('click', function () { state.colour = c.id; save(); sw.querySelectorAll('.aptm__swatch').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); });
    sw.appendChild(b);
  });

  var total = COUNTIES.length; $('total').textContent = total;
  function paint() {
    var n = 0;
    COUNTIES.forEach(function (c) {
      var v = state.visited[c.id], p = paths[c.id];
      if (v) { n++; p.classList.add('is-on'); p.style.fill = hexOf(v); } else { p.classList.remove('is-on'); p.style.fill = ''; }
      p.setAttribute('aria-pressed', String(!!v));
      var cb = boxes[c.id].cb; cb.checked = !!v;
      if (v) cb.setAttribute('checked', ''); else cb.removeAttribute('checked');
      boxes[c.id].dot.style.background = v ? hexOf(v) : 'transparent';
    });
    $('n').textContent = n; $('bar').style.width = (n / total * 100) + '%';
  }
  var toastEl = $('toast'), tt;
  function toast(msg) { toastEl.textContent = msg; toastEl.classList.add('is-show'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('is-show'); }, 1600); }
  function toggle(id, force) {
    var cur = state.visited[id];
    // Tapping a coloured county always clears it, whatever colour it is.
    var on = force === undefined ? !cur : force;
    if (on) state.visited[id] = state.colour; else delete state.visited[id];
    save(); paint(); toast(nameOf(byId[id]) + (on ? ' coloured in' : ' cleared'));
  }
  svg.addEventListener('keydown', function (e) {
    var id = e.target.getAttribute && e.target.getAttribute('data-id');
    if ((e.key === 'Enter' || e.key === ' ') && id) { e.preventDefault(); toggle(id); }
  });

  // Pan, pinch and tap
  var pts = new Map(), downTarget = null, moved = false, start = null, pinch0 = null;
  function toSvg(cx, cy) { var r = svg.getBoundingClientRect(); return { x: vb.x + (cx - r.left) / r.width * vb.w, y: vb.y + (cy - r.top) / r.height * vb.h }; }
  function clampVB() {
    vb.w = Math.min(full.w, Math.max(full.w / 8, vb.w)); vb.h = vb.w * full.h / full.w;
    vb.x = Math.min(full.x + full.w - vb.w, Math.max(full.x, vb.x)); vb.y = Math.min(full.y + full.h - vb.h, Math.max(full.y, vb.y)); setVB();
  }
  function zoomAt(f, cx, cy) {
    var p = cx == null ? { x: vb.x + vb.w / 2, y: vb.y + vb.h / 2 } : toSvg(cx, cy);
    var fx = (p.x - vb.x) / vb.w, fy = (p.y - vb.y) / vb.h;
    vb.w = vb.w / f; vb.h = vb.w * full.h / full.w; vb.x = p.x - fx * vb.w; vb.y = p.y - fy * vb.h; clampVB();
  }
  svg.addEventListener('pointerdown', function (e) {
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 1) { downTarget = e.target; moved = false; start = { x: e.clientX, y: e.clientY, vb: { x: vb.x, y: vb.y } }; }
    if (pts.size === 2) { var a = Array.from(pts.values()); pinch0 = { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), w: vb.w }; moved = true; }
  });
  svg.addEventListener('pointermove', function (e) {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 2 && pinch0) {
      var a = Array.from(pts.values()), d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
      zoomAt(vb.w / (pinch0.w * pinch0.d / d), (a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2); return;
    }
    if (pts.size === 1 && start) {
      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (!moved && Math.hypot(dx, dy) > 8 && vb.w < full.w) { moved = true; try { svg.setPointerCapture(e.pointerId); } catch (err) {} }
      if (moved) { var r = svg.getBoundingClientRect(); vb.x = start.vb.x - dx / r.width * vb.w; vb.y = start.vb.y - dy / r.height * vb.h; clampVB(); }
    }
  });
  function up(e) {
    var only = pts.size === 1; pts.delete(e.pointerId); if (pts.size < 2) pinch0 = null;
    var id = downTarget && downTarget.getAttribute && downTarget.getAttribute('data-id');
    if (only && !moved && id && e.type === 'pointerup') toggle(id);
    if (pts.size === 0) { downTarget = null; start = null; }
  }
  svg.addEventListener('pointerup', up); svg.addEventListener('pointercancel', up);
  svg.addEventListener('wheel', function (e) { if (!e.ctrlKey && !e.metaKey) return; e.preventDefault(); zoomAt(e.deltaY < 0 ? 1.2 : 1 / 1.2, e.clientX, e.clientY); }, { passive: false });
  $('zin').addEventListener('click', function () { zoomAt(1.5); });
  $('zout').addEventListener('click', function () { zoomAt(1 / 1.5); });
  $('zreset').addEventListener('click', function () { vb = { x: full.x, y: full.y, w: full.w, h: full.h }; setVB(); });

  // Title
  var tIn = $('title'), sIn = $('sub'), outT = $('out-title'), outS = $('out-sub');
  tIn.value = state.title || ''; sIn.value = state.sub || '';
  function syncText() { state.title = tIn.value; state.sub = sIn.value; outT.textContent = state.title.trim() || 'My Touring Map'; outS.textContent = state.sub.trim(); save(); }
  tIn.addEventListener('input', syncText); sIn.addEventListener('input', syncText); syncText();

  var clearBtn = $('clear'), confirmBox = $('confirm');
  clearBtn.addEventListener('click', function () { clearBtn.hidden = true; confirmBox.hidden = false; $('clear-no').focus(); });
  $('clear-no').addEventListener('click', function () { confirmBox.hidden = true; clearBtn.hidden = false; clearBtn.focus(); });
  $('clear-yes').addEventListener('click', function () {
    state.visited = {}; save(); paint(); confirmBox.hidden = true; clearBtn.hidden = false; toast('Map cleared');
  });

  // Modals
  var gate = $('gate'), shot = $('shot'), lastFocus = null;
  function open(m) { lastFocus = document.activeElement; m.hidden = false; document.documentElement.classList.add('aptm-lock'); var f = m.querySelector('input, a, button:not(.aptm__x)'); if (f) f.focus(); }
  function close(m) { m.hidden = true; document.documentElement.classList.remove('aptm-lock'); if (lastFocus) lastFocus.focus(); }
  [gate, shot].forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-aptm-close]')) close(m); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (!gate.hidden) close(gate); if (!shot.hidden) close(shot); } });

  // Share picture (1080 x 1350, portrait for Instagram and Facebook)
  var FONT = (getComputedStyle(root.querySelector('[data-aptm-font]')).fontFamily || 'sans-serif');
  var BODYFONT = (getComputedStyle(root).fontFamily || 'sans-serif');
  function fit(ctx, text, max, size, weight, fam) { var s = size; do { ctx.font = weight + ' ' + s + 'px ' + fam; s -= 2; } while (ctx.measureText(text).width > max && s > 20); }
  function loadLogo() {
    return new Promise(function (res) {
      var src = root.dataset.logo; if (!src) return res(null);
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = function () { res(null); };
      im.src = src.indexOf('//') === 0 ? location.protocol + src : src;
    });
  }
  function draw(logo) {
    var W = 1080, H = 1350, c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d');
    x.fillStyle = '#F7F4EE'; x.fillRect(0, 0, W, H);
    var title = state.title.trim() || 'My Touring Map';
    x.fillStyle = '#1D1D1B'; fit(x, title, W - 120, 64, 800, FONT); x.fillText(title, 60, 110);
    var sub = state.sub.trim();
    if (sub) { x.fillStyle = '#6B665D'; fit(x, sub, W - 120, 34, 600, BODYFONT); x.fillText(sub, 60, 160); }
    var top = 190, bottom = H - 230, areaH = bottom - top, areaW = W - 120;
    var sc = Math.min(areaW / MAP.w, areaH / MAP.h), ox = (W - MAP.w * sc) / 2, oy = top + (areaH - MAP.h * sc) / 2;
    x.save(); x.translate(ox, oy); x.scale(sc, sc); x.translate(-MAP.x, 0);
    x.lineJoin = 'round'; x.lineWidth = 1.8; x.strokeStyle = '#F7F4EE';
    COUNTIES.forEach(function (cn) { var p = new Path2D(cn.d), v = state.visited[cn.id]; x.fillStyle = v ? hexOf(v) : '#DDD7CB'; x.fill(p, 'evenodd'); x.stroke(p); });
    x.setLineDash([6, 6]); x.strokeStyle = '#A9A296'; x.lineWidth = 1.6; x.strokeRect(MAP.inset[0], MAP.inset[1], MAP.inset[2], MAP.inset[3]); x.setLineDash([]);
    x.restore();
    var n = Object.keys(state.visited).length, big = n + ' of ' + total;
    x.fillStyle = '#1D1D1B'; x.font = '800 52px ' + FONT; x.fillText(big, 60, H - 180);
    var bw = x.measureText(big).width; x.font = '600 30px ' + BODYFONT; x.fillStyle = '#6B665D'; x.fillText('counties toured', 60 + bw + 16, H - 180);
    // Branded footer: white band with the logo on the left and the call to action on the right
    var bandTop = H - 140;
    x.fillStyle = '#FFFFFF'; x.fillRect(0, bandTop, W, 140);
    x.fillStyle = '#1C8C93'; x.fillRect(0, bandTop, W, 6);
    x.textAlign = 'right';
    x.fillStyle = '#1C8C93'; x.font = '800 34px ' + FONT; x.fillText('Colour in yours free', W - 60, H - 72);
    x.fillStyle = '#1D1D1B'; x.font = '600 28px ' + BODYFONT; x.fillText('adventureparked.com', W - 60, H - 34);
    x.textAlign = 'left';
    if (logo) {
      var maxW = 400, maxH = 104, r = Math.min(maxW / logo.width, maxH / logo.height);
      var lw = logo.width * r, lh = logo.height * r;
      x.drawImage(logo, 60, bandTop + 6 + (134 - lh) / 2, lw, lh);
    } else {
      x.fillStyle = '#1D1D1B'; x.font = '800 40px ' + FONT; x.fillText('Adventure Parked', 60, H - 52);
    }
    return c;
  }
  var blobUrl = null, file = null;
  function makePicture() {
    return (document.fonts ? document.fonts.ready : Promise.resolve()).then(loadLogo).then(function (logo) {
      var c = draw(logo);
      return new Promise(function (res) {
        try { c.toBlob(function (b) { res(b); }, 'image/png'); }
        catch (e) { draw(null).toBlob(function (b) { res(b); }, 'image/png'); } // logo blocked the canvas: draw without it
      });
    });
  }
  $('save').addEventListener('click', function () {
    if (!member) { open(gate); return; }
    makePicture().then(function (b) {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
      blobUrl = URL.createObjectURL(b); $('img').src = blobUrl; $('download').href = blobUrl;
      file = null; var shareBtn = $('share'); shareBtn.hidden = true;
      try {
        var f = new File([b], 'my-touring-map.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [f] })) { file = f; shareBtn.hidden = false; }
      } catch (e) {}
      open(shot);
    });
  });
  $('share').addEventListener('click', function () {
    if (!file) return;
    navigator.share({ files: [file], title: 'My touring map', text: 'Colour in yours free at adventureparked.com' }).catch(function () {});
  });

  // Download: blob links can't open inside the theme editor, and some browsers ignore the download attribute.
  $('download').addEventListener('click', function (e) {
    e.preventDefault();
    if (window.Shopify && window.Shopify.designMode) { shot.querySelector('.aptm__hint').textContent = 'Downloads are switched off inside the theme editor. This button works on the live page.'; return; }
    if (!blobUrl) return;
    var a = document.createElement('a');
    if ('download' in a) { a.href = blobUrl; a.download = 'my-touring-map.png'; document.body.appendChild(a); a.click(); a.remove(); }
    else window.open(blobUrl, '_blank');
  });

  // First visit: a few sample counties so the map isn't empty
  if (firstVisit && !linkLoaded && !Object.keys(state.visited).length) {
    ['cornwall','devon','dorset','north-yorkshire','cumbria','gwynedd','inverness','norfolk'].forEach(function (id, i) { if (byId[id]) state.visited[id] = COLOURS[i % 3].id; });
  }
  paint();
  if (linkLoaded) toast('Your map is loaded');
  else if (justJoined) toast('Welcome to the club! Your map is unlocked');
  else if (alreadyMember) toast('Welcome back! Your map is unlocked');
  else if (gateErr) open(gate); // show the sign-up error so they can fix it
  else if (firstVisit) toast('Sample counties shown. Tap to change them');
}
function initAll() { document.querySelectorAll('[data-aptm-root]').forEach(initTouringMap); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-aptm-root]'); if (r) initTouringMap(r); });
})();
